import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import api from "../../../api/api";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from 'react-toastify'
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

const ReceivedCreate = () => {
  const { register, handleSubmit, unregister } = useForm();

  const [transactionDatas, setTransactionDatas] = useState([]);
  const [showPaymentMode, setShowPaymentMode] = useState("cash");

  const [results, setResults] = useState([])
  const [transactionId, setTransactionId] = useState(null)
  const [cmpId, setCmpId] = useState(null)
  const [companyName, setCompanyName] = useState("")
  const [receiptId, setReceiptId] = useState(null)
  const [receiptShow, setReceiptShow] = useState({})


  useEffect(() => {
    api
      .get("/transactions/no-receipt/")
      .then((response) => {
        // console.log(response.data)
        setTransactionDatas(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  useEffect(() => {
    if (showPaymentMode === "cheque") {
      unregister("bank_name_1")
      unregister("e_wallet_number")

    } else if (showPaymentMode === "bank") {
      unregister("e_wallet_number")
      unregister("bank_name")
      unregister("cheque_number")
      unregister("cheque_holder_name")
      unregister("check_exchange_date")

    } else {
      unregister("e_wallet_number")
      unregister("bank_name")
      unregister("cheque_number")
      unregister("cheque_holder_name")
      unregister("check_exchange_date")
      unregister("bank_name_1")
      unregister("e_wallet_number")
    }


  }, [showPaymentMode])


  const handleChange = (e) => {
    // console.log(e.target.value)
    setShowPaymentMode(e.target.value);
  };


  const handleSub = (data) => {
    // console.log('data',data)
    // data.company = 1;
    data.transaction = transactionId

    const user = JSON.parse(localStorage.getItem("user"));
    data.created_by = user.user_id;
    data.company = cmpId
    data.company_name = companyName




    if (showPaymentMode === "bank") {
      data.bank_name = data.bank_name_1
    }

    // console.log(data)
    api.post("/transactions/receipts/", data)
      .then(response => {
        setReceiptId(response.data.id)
        toast.success("Receipt created successfully Successfully")


      }).catch(error => {
        toast.error("Something went wrong")
      })

  };


  const handleApprove = (data) => {

    api.post(`/transactions/receipts/${receiptId}/approve/`, data)
      .then(response => {
        toast.success("Receipt approve successfully")
        setReceiptId(null)
      }).catch(error => {
        toast.error("Something went wrong")
      })

  }


  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item)
    api
      .get(`/transactions/no-receipt/?id=${item.id}`)
      .then((response) => {
        console.log("Result", response.data)
        setResults(response.data);
        setTransactionId(response.data[0].id)
        setCmpId(response.data[0].company)
        setCompanyName(response.data[0].company_name)

      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };


  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  const displayReceipt = (data) => {
    setReceiptShow(data)

  }
  const printRef=useRef(null)
  const print = useReactToPrint ({
    content: () => printRef.current,
  });

  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Receipt
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* Create receive  table */}
      <div className="w-padding mt-10">
        <form className="">
          <div className="grid lg:grid-cols-2">
            {/* left items */}
            <div className="">
              <div className="border-primary-blue flex items-center gap-2 border px-3">

                <div style={{ width: 400 }}>
                  <ReactSearchAutocomplete
                    items={transactionDatas}
                    onSearch={handleOnSearch}
                    onHover={handleOnHover}
                    onSelect={handleOnSelect}
                    onFocus={handleOnFocus}
                    autoFocus
                    formatResult={formatResult}
                  />
                </div>

                {/* <p className="text-primary-red font-bold">Transaction:</p>
                <select
                  name=""
                  onC={(e) => console.log(e.target.value)}
                  {...register("transaction", { required: false })}
                  id="company_select"
                  className="border-primary-blue w-full border p-2"
                >
                  <option value="Select">Select</option>

                  {transactionDatas?.map((item, i) => {
                    return (
                      <option value={item.id} key={i}>
                        {item.amount} &nbsp; &nbsp;
                        {item.customer_name === "" && item.customer_email}{" "}
                        &nbsp; &nbsp; Name:{item.company_name}
                        &nbsp; &nbsp;
                        {item.created_at}
                      </option>
                    );
                  })}
                </select> */}
              </div>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">Receiped Date:</p>
                <input
                  type="date"
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                  {...register("received_date", { required: false })}
                />
              </div>
              <div className="border-primary-blue flex items-center gap-2 border border-t-0 border-r-0 p-2">
                <label htmlFor="" className="text-primary-red font-bold">
                  Company Name:
                </label>
                <div className="flex-grow items-center gap-2 lg:flex">

                  <input
                    type="text"
                    // defaultValue=""
                    {...register("company_name", { required: false })}
                    id="company_name"
                    value={results[0]?.company_name ? results[0]?.company_name : ""}
                    className="border-primary-blue w-full flex-grow border p-2 outline-none"
                    placeholder=" company name"
                  />
                </div>
              </div>
              <div className="border-primary-blue flex items-center gap-2 border border-t-0 px-3">
                <p className="text-primary-red font-bold">Receiped Details:</p>
                <input
                  type="text"
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                  {...register("received_details", { required: false })}
                />
              </div>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">
                  Payment giver name:
                </p>
                <input
                  type="text"
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                  {...register("payers_name", { required: false })}
                />
              </div>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">
                  Payment giver Contact:
                </p>
                <input
                  type="number"
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                  {...register("payers_contact", { required: false })}
                />
              </div>
              <div className="border-primary-blue flex flex-wrap items-center gap-2 border p-3 text-sm">
                <p className="text-primary-red font-bold">Received Mode:</p>
                <input
                  type="radio"
                  name="pay"
                  value="cash"
                  defaultChecked
                  onClick={(e) => handleChange(e)}
                  className="placeholder:text-primary-blue"
                  {...register("payment_mode", { required: false })}
                />
                <label htmlFor="">Cash</label>
                <input
                  type="radio"
                  name="pay"
                  value="cheque"
                  onClick={(e) => handleChange(e)}
                  {...register("payment_mode", { required: false })}
                  className="placeholder:text-primary-blue"
                />
                <label htmlFor="">Cheque</label>
                <input
                  type="radio"
                  name="pay"
                  value="bank"
                  onClick={(e) => handleChange(e)}
                  {...register("payment_mode", { required: false })}
                  className="placeholder:text-primary-blue"
                />
                <label htmlFor="">Bank Transfer</label>
                <input
                  type="radio"
                  name="pay"
                  value="e-wallet"
                  onClick={(e) => handleChange(e)}
                  {...register("payment_mode", { required: false })}
                  className="placeholder:text-primary-blue"
                />
                <label htmlFor="">Esewa</label>
                {/* <input
                  type="radio"
                  name="pay"
                  value="e-wallet"
                  {...register("payment_mode", { required: false })}
                  className="placeholder:text-primary-blue"
                /> */}
              </div>
            </div>
            {/* right items */}
            <div className="">
              <div className="border-primary-blue flex items-center gap-2 border border-l-0 px-3">
                <p className="text-primary-red font-bold">Pan no:</p>
                <input
                  type="text"
                  {...register("company_pan", { required: false })}
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                />
              </div>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">Company Address:</p>
                <input
                  type="text"
                  {...register("company_address", { required: false })}
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                />
              </div>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">
                  Relation with company:
                </p>
                <input
                  type="text"
                  tooltip="Relation of payer with the company"
                  {...register("relation_with_company", { required: false })}
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                />
              </div>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">Received Amount:</p>
                <input
                  type="text"
                  // {...register("", { required: false })}
                  value={results[0]?.amount ? results[0]?.amount : ""}
                  disabled
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                />
              </div>
            </div>
          </div>
          {/* cheque */}
          {showPaymentMode === "cheque" && (
            <>
              <h1 className="text-primary-blue mt-6 text-center font-bold">
                If cheque
              </h1>
              <div className="grid md:grid-cols-2">
                {/* left items */}
                <div className="">
                  <div className="border-primary-blue flex items-center gap-2 border px-3">
                    <p className="text-primary-red font-bold">Bank Name:</p>
                    <input
                      type="text"
                      className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                      {...register("bank_name", {
                        // required : false
                      })}
                    />
                  </div>
                  <div className="border-primary-blue flex items-center gap-2 border px-3">
                    <p className="text-primary-red font-bold">Cheque No:</p>
                    <input
                      type="text"
                      className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                      {...register("cheque_number", {
                        // required : false
                      })}
                    />
                  </div>
                </div>
                {/* right items */}
                <div className="">
                  <div className="border-primary-blue flex items-center gap-2 border px-3">
                    <p className="text-primary-red font-bold">
                      Cheque holder name:
                    </p>
                    <input
                      type="text"
                      className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                      {...register("cheque_holder_name", {
                        // required : false
                      })}
                    />
                  </div>
                  <div className="border-primary-blue flex items-center gap-2 border px-3">
                    <p className="text-primary-red font-bold">
                      Cheque exchane date:
                    </p>
                    <input
                      type="date"
                      className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                      {...register("check_exchange_date", {
                        // required : false
                      })}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {showPaymentMode === "bank" && (
            <>
              <h1 className="text-primary-blue mt-6 text-center font-bold">
                If Bank
              </h1>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">Bank Name:</p>
                <input
                  type="text"
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                  {...register("bank_name_1", {
                    // required : false
                  })}
                />
              </div>
            </>
          )}
          {/* bank */}

          {showPaymentMode === "e-wallet" && (
            <>
              <h1 className="text-primary-blue mt-6 text-center font-bold">
                Esewa
              </h1>
              <div className="border-primary-blue flex items-center gap-2 border px-3">
                <p className="text-primary-red font-bold">Esewa number:</p>
                <input
                  type="text"
                  className="placeholder:text-primary-blue flex-grow p-3 outline-none"
                  {...register("e_wallet_number", {
                    // required : false
                  })}
                />
              </div>
            </>
          )}
          {/* E sewa */}

          {/* submit button */}
          <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
            <button onClick={handleSubmit(displayReceipt)}>Save</button>
          </div>
          <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
            <button onClick={handleSubmit(handleSub)}>Submit</button>
          </div>

          {
            receiptId &&
            <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
              {/* <a href="">Approved</a> */}

              <button onClick={handleSubmit(handleApprove)}>
                Approve</button>

            </div>
          }


        </form>
      </div>
      {/* print bill */}

      <section className="mt-10 w-full sm:px-5 md:px-10">
        <div  ref={printRef} className="flex w-full max-w-[910px] flex-col gap-2 overflow-hidden border-2 border-green-500 p-2 md:mx-auto">
          <div className="flex items-center justify-between text-lg font-medium text-red-500 sm:text-sm md:text-base">
            <h1>
              Redg. No. :<span className="text-cyan-500">10419/075/076</span>
            </h1>
            <h1>
              Redg. No. :<span className="text-cyan-500">10419/075/076</span>
            </h1>
            <h1>
              Redg. No. :<span className="text-cyan-500">10419/075/076</span>
            </h1>
          </div>
          <div className="flex flex-col items-center justify-center gap-1">
            <h1 className="text-lg font-bold text-red-600 md:text-3xl">
              Graphic Marg Pvt. Ltd.
            </h1>
            <p className="text-lg font-bold text-cyan-600 sm:text-sm md:text-base">
              Bharatpur-11, Bypass Road, Chitwan
            </p>
            <p className="text-lg font-bold text-red-600 sm:text-sm md:text-base">
              Contact No.:
              <span className="text-cyan-600">056-590279, 9855022279</span>
            </p>
          </div>
          <div className="flex flex-col justify-center">
            <div className="flex justify-between text-lg font-semibold text-red-500 sm:text-sm md:text-lg">
              <h1>
                Receipt No. : <span className="text-cyan-500">{receiptId}</span>
              </h1>
              <div className="hidden rounded-tl-xl rounded-br-xl border border-white bg-red-500 py-1 px-2 text-lg text-white shadow-md shadow-black sm:flex sm:text-xl">
                Money Receipt
              </div>
              <h1>
                Date : <span className="text-cyan-500">{receiptShow?.received_date}</span>
              </h1>
            </div>
          </div>
          <div className="sm:sm mt-5 flex flex-col gap-1 text-lg font-medium text-red-500 md:text-lg">
            <div>
              Received From (Company Name) :
              <span className="text-cyan-500">{receiptShow?.company_name}</span>
            </div>
            <div className="flex gap-5 sm:gap-16">
              <p>
                Address :
                <span className="text-cyan-500">{receiptShow?.company_address}</span>
              </p>
              <p>
                PAN No. : <span className="text-cyan-500">{receiptShow?.company_pan}</span>
              </p>
            </div>
            <div>
              The Sum of Rupees :<span className="text-cyan-500">{results[0]?.amount ? results[0]?.amount : ""}</span>{" "}
              only.
            </div>
            <div>
              By  <span className="text-cyan-500">{receiptShow?.payment_mode}</span>  in Payment of Your Account.
            </div>
            <div>Payment Received Details: <span className="text-cyan-500"> {receiptShow?.received_details}</span></div>

            {/* Bank payment */}


            {
              showPaymentMode === "cheque" && <div>
                <div className="flex gap-2">
                  <p className="text-green-500 underline">Cheque Details :</p>
                  <div>
                    Bank Name:
                    <span className="text-cyan-500">{receiptShow?.bank_name}</span>
                  </div>
                </div>
                <h1 className="flex gap-5 sm:gap-16">

                  <p>
                    Cheque No. :<span className="text-cyan-500">{receiptShow?.cheque_number}</span>
                  </p>
                  <p>
                    Cheque Exchange Date :
                    <span className="text-cyan-500">{receiptShow?.check_exchange_date}</span>
                  </p>
                </h1>
              </div>
            }
            {
              showPaymentMode === "bank" && (  <div className="flex gap-2">
              <p className="text-green-500 underline">Bank Details :</p>
              <div>
                Bank Name:
                <span className="text-cyan-500">{receiptShow?.bank_name_1}</span>
              </div>
            </div>)
            }
          

            {
              showPaymentMode === "e-wallet" && (<div className="flex gap-2">
                <p className="text-green-500 underline"> Esewa Details :</p>
                <div>
                  Esewa Name/Esewa ID :
                  <span className="text-cyan-500">{receiptShow?.e_wallet_number}</span>
                </div>
              </div>)
            }

          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-center">
              <div className="flex items-center gap-2 rounded-tl-xl rounded-br-xl border-2 border-red-500 py-1 px-2 text-lg sm:text-xl">
                <p className="rounded-tl-xl rounded-br-xl border-2 border-blue-500 bg-red-500 py-1 px-2 text-lg text-white sm:text-xl">
                  Rs.
                </p>
                <h1 className="rounded-tl-xl rounded-br-xl border-2 border-green-500 py-1 px-2 text-lg text-blue-500 sm:text-xl">
                  <span className="text-green-500">Rs.</span> {results[0]?.amount ? results[0]?.amount : ""}
                </h1>
              </div>
            </div>
            <div className="sm:sm mt-5 flex flex-col gap-1 border-2 border-pink-400 px-3 py-2 text-lg font-medium text-red-500 md:text-lg">
              <h1 className="text-green-500 underline">Payment Giver's</h1>
              <p>
                Name : <span className="text-cyan-500">{receiptShow?.payers_name}</span>
              </p>
              <p>
                Contact No. :<span className="text-cyan-500">{receiptShow?.payers_contact}</span>
              </p>
              <p>
                Re.With Com. : <span className="text-cyan-500">{receiptShow?.relation_with_company}</span>
              </p>
            </div>
            <div className="sm:sm mt-5 flex flex-col gap-1 border-2 border-pink-400 px-3 py-2 text-lg font-medium text-red-500 md:text-lg">
              <h1 className="text-green-500 underline">Payment Receiver's</h1>
              <p>
                Signature :
                <span className="text-cyan-500">........................</span>
              </p>
              <p>
                Name : 
              </p>
              <p>
                Post : 
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-end">
      <button onClick={print} className="px-2 mt-0  py-1  bg-primary-blue  rounded-xl text-white">Print </button>
  </div>
      </section>
    </div>
  );
};

export default ReceivedCreate;
